import { render } from "./Snapchat.vue?vue&type=template&id=9bb438d0"
import script from "./Snapchat.vue?vue&type=script&lang=js"
export * from "./Snapchat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__